import type { BulkPromoStatus, JobDetails } from '@/types';

const keysToCompare: (keyof JobDetails)[] = [
    'jobId',
    'status',
    'generatedCodesCount',
    'failedToGenerateCodesCount',
    'fetchedCodesCount',
    'updatedAt',
];

export const haveBulkPromosChanged = (prevPromos: JobDetails[], newPromos: JobDetails[]): boolean => {
    if (prevPromos.length !== newPromos.length) {
        return true;
    }

    return prevPromos.some((prevPromo, idx) => {
        const newPromo = newPromos[idx];
        return keysToCompare.some(key => prevPromo[key] !== newPromo[key]);
    });
};

const statusPriority: Record<BulkPromoStatus, number> = {
    processing: 1,
    pending: 2,
    'complete-with-errors': 3,
    complete: 4,
    failed: 5,
};

export const sortBulkPromos = (promos: JobDetails[]): JobDetails[] =>
    [...promos].sort((a, b) => {
        const statusDiff = statusPriority[a.status as BulkPromoStatus] - statusPriority[b.status as BulkPromoStatus];

        if (statusDiff !== 0) {
            return statusDiff;
        }

        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
